import React from "react";

const PECCertificates = () => {
  return (
    <div className="flex justify-center px-4 py-10 bg-white">
      <div className="w-full lg:w-[90%] max-w-6xl">
        {/* Heading */}
        <h2 className="text-3xl font-bold mb-3 text-gray-800">PEC Certificates</h2>
        <h3 className="text-xl font-semibold mb-2 text-teal-700">
          PEC Certified Construction Company in Lahore, Pakistan
        </h3>
        <p className="text-gray-700 mb-8">
          Pakistan Engineering Council awarded Category C2 to{" "}
          <strong>PACIFIC BUILDERS (PVT) LTD</strong> for performing high-quality
          construction operations across the country.
        </p>

        {/* Main Image - Office or Building */}
        <div className="mb-8">
          <img
            src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
            alt="PEC Building"
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        {/* Certificate Images */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <img
            src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
            alt="PEC License Certificate 1"
            className="w-full rounded-lg shadow-md"
          />
          <img
            src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
            alt="PEC License Certificate 2"
            className="w-full rounded-lg shadow-md"
          />
        </div> */}
      </div>
    </div>
  );
};

export default PECCertificates;


// import React from "react";

// const PECCertificates = () => {
//   return (
//     <div className="flex justify-center px-4 py-10 bg-white">
//       <div className="w-full lg:w-[90%] max-w-6xl">
//         {/* Heading */}
//         <h2 className="text-3xl font-bold mb-3 text-gray-800">Certifications</h2>
//         <h3 className="text-xl font-semibold mb-2 text-teal-700">
//           Certified Construction Company in Lahore, Pakistan
//         </h3>
//         <p className="text-gray-700 mb-8">
//           <strong>PACIFIC BUILDERS (PVT) LTD</strong> is officially recognized and certified
//           by both the Pakistan Engineering Council (PEC) and the Constructors Association
//           of Pakistan (CAP) to undertake high-quality construction projects across the country.
//         </p>

//         {/* Images Section */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* PEC Certificate */}
//           <div className="flex flex-col items-center">
//             <img
//               src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
//               alt="PEC Certificate"
//               className="w-full rounded-lg shadow-lg"
//             />
//             <h4 className="mt-4 text-lg font-semibold text-gray-800">
//               Pakistan Engineering Council (PEC) Certificate
//             </h4>
//             <p className="text-sm text-gray-600 text-center">
//               Category C2 certified by PEC for nationwide construction operations.
//             </p>
//           </div>

//           {/* CAP Certificate */}
//           <div className="flex flex-col items-center">
//             <img
//               src="/images/Cap_page-0001.jpg"
//               alt="CAP Certificate"
//               className="w-full rounded-lg shadow-lg"
//             />
//             <h4 className="mt-4 text-lg font-semibold text-gray-800">
//               Constructors Association of Pakistan (CAP) Membership
//             </h4>
//             <p className="text-sm text-gray-600 text-center">
//               Membership No: CAP-1768 | Valid till: 31st March, 2026
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PECCertificates;
